import Vue from 'vue'
import global from '@/config/global'
import OSS from 'ali-oss'
import axios from 'axios'

export default async (file) => new Promise(async (resolve, reject) => {
    try {
        console.log('图片上传---->', global.baseApi);
        console.log('图片上传---->', file);

        // 判断尺寸 
        const MAX_SIZE = 400 * 1024; // 400KB
        if (file.size > MAX_SIZE) {
            // 拦截超大图片，提示用户
            const sizeKB = Math.round(file.size / 1024);
            reject({
                message: `图片文件尺寸为 ${sizeKB}KB，超过 400KB 限制，请压缩后再上传`,
                status: 10001
            });
            return;
        }

        if (file.size <= 400000) {
            // 通过接口获取阿里云 STS 临时凭证
            console.log('====== 开始获取阿里云 STS 临时凭证 ======');
            console.log('请求接口:', 'https://xcx02.keduozan.com/tools/post.ashx');

            // 使用 URLSearchParams 模拟 jQuery ajax 的 data 格式
            const params = new URLSearchParams();
            params.append('act', 'GetALiSTS');
            params.append('s_manager', '');
            console.log('请求参数 (x-www-form-urlencoded):', params.toString());

            const stsResponse = await axios.post('https://xcx02.keduozan.com/tools/post.ashx', params, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            });

            console.log('STS 接口响应状态:', stsResponse.status);
            console.log('STS 接口响应头:', stsResponse.headers);
            console.log('STS 接口完整响应数据:', stsResponse.data);

            if (stsResponse.data.status !== 1) {
                console.error('❌ 获取 STS 凭证失败:');
                console.error('  - status:', stsResponse.data.status);
                console.error('  - msg:', stsResponse.data.msg);
                console.error('  - 完整响应:', stsResponse.data);
                reject(new Error(stsResponse.data.msg || '获取阿里云凭证失败'));
                return;
            }

            console.log('✅ 获取 STS 凭证成功:');
            console.log('  - AccessKeyId:', stsResponse.data.AccessKeyId);
            console.log('  - AccessKeySecret:', stsResponse.data.AccessKeySecret ? stsResponse.data.AccessKeySecret.substring(0, 6) + '******' : '空');
            console.log('  - SecurityToken:', stsResponse.data.SecurityToken ? stsResponse.data.SecurityToken.substring(0, 20) + '...' : '空');

            const { AccessKeyId, AccessKeySecret, SecurityToken } = stsResponse.data;

            if (!AccessKeyId || !AccessKeySecret || !SecurityToken) {
                console.error('❌ STS 凭证字段不完整:');
                console.error('  - AccessKeyId:', AccessKeyId);
                console.error('  - AccessKeySecret:', AccessKeySecret ? '有值' : '空');
                console.error('  - SecurityToken:', SecurityToken ? '有值' : '空');
                reject(new Error('STS 凭证字段不完整'));
                return;
            }

            console.log('====== STS 凭证获取完成，开始创建 OSS 客户端 ======');

            // 创建 OSS 客户端，使用 STS 临时凭证
            const client = new OSS({
                region: 'oss-cn-shanghai',
                accessKeyId: AccessKeyId,
                accessKeySecret: AccessKeySecret,
                stsToken: SecurityToken,
                bucket: 'kdz-2023-photo-001',
                secure: true, // 强制使用 HTTPS
                cname: false
            });

            // 生成文件路径和文件名
            const now = new Date();
            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const day = String(now.getDate()).padStart(2, '0');
            const timestamp = now.getTime();
            const fileName = `${year}${month}${day}/${timestamp}-${file.name}`;

            console.log('准备上传文件到 OSS:', `upload/${fileName}`);

            // 上传文件到 OSS
            const result = await client.put(`upload/${fileName}`, file);

            console.log('OSS 上传响应:', result);
            console.log('OSS 上传响应状态:', result.res.status);

            if (result.res.status === 200) {
                // 构建文件 URL
                const fileUrl = `https://kdz-2023-photo-001.oss-cn-shanghai.aliyuncs.com/upload/${fileName}`;
                console.log('✅ 阿里云 OSS 上传成功---->', fileUrl);
                resolve(fileUrl);
            } else {
                console.error('❌ 阿里云 OSS 上传失败，状态码:', result.res.status);
                reject(new Error('阿里云 OSS 上传失败'));
            }
        }
    } catch (error) {
        console.error('阿里云 OSS 上传错误---->', error);
        reject(error);
    }
})
